import { AttackType } from '@wareena/grid-battles-entity/game/codebook/attackTypes';
import { getPathToApproach } from '../utils/getReachablePath/index.js';
import { getChanceToDealHits } from '../utils/getHitsProbability.js';
import hasLosFromPositionOrig from '../utils/hasLosFromPosition.js';
import { getRandomInteger } from '@wareena/game-algorithms';
import { getTerrainPreferencesForAttack } from '../utils/terrainPreferences.js';
const moveTowardsEnemyStrategyFactory = (agentSide, hexProperties, rules, mapHexes) => {
    const hasLosFromPosition = (agentUnit, fromPosition, enemyPosition, allUnits) => {
        return hasLosFromPositionOrig({
            range: agentUnit.range,
            fromPosition,
            targetPosition: enemyPosition,
            allUnits,
            hexProperties,
            rules,
        });
    };
    return {
        name: 'moveTowardsEnemyStrategy',
        getMoveOrder: (gameState) => {
            const agentFreshUnits = gameState.units.filter((unit) => unit.side === agentSide && !unit.isFatigued);
            const enemyUnits = gameState.units.filter((unit) => unit.side !== agentSide);
            const agentCandidates = [];
            agentFreshUnits.forEach((agentUnit) => {
                enemyUnits.forEach((enemyUnit) => {
                    let path = [];
                    const pathToApproach = getPathToApproach(agentUnit, enemyUnit, hexProperties, rules, gameState.units, mapHexes, getTerrainPreferencesForAttack());
                    if (!pathToApproach) {
                        return;
                    }
                    if (agentUnit.attackType === AttackType.Melee) {
                        path = pathToApproach;
                    }
                    else if (agentUnit.attackType === AttackType.Ranged) {
                        let idxToLeave = pathToApproach.length;
                        for (let i = 0; i < pathToApproach.length; i += 1) {
                            const position = pathToApproach[i];
                            if (hasLosFromPosition(agentUnit, position, enemyUnit.position, gameState.units)) {
                                idxToLeave = i + 1;
                                break;
                            }
                        }
                        path = pathToApproach.slice(0, idxToLeave);
                    }
                    const newPosition = path.length ? path[path.length - 1] : null;
                    const chanceForEnoughHits = getChanceToDealHits({ ...agentUnit, position: newPosition ?? agentUnit.position }, enemyUnit, 1, rules);
                    agentCandidates.push({ agentUnit, enemyUnit, chanceForEnoughHits, path });
                });
            });
            if (agentCandidates.length > 0) {
                agentCandidates.sort((a, b) => {
                    if (a.chanceForEnoughHits === b.chanceForEnoughHits) {
                        return getRandomInteger(0, 1) ? -1 : 1;
                    }
                    return b.chanceForEnoughHits - a.chanceForEnoughHits;
                });
                const candidate = agentCandidates[0];
                return {
                    agentUnit: candidate.agentUnit,
                    targetPosition: candidate.path.length
                        ? candidate.path[candidate.path.length - 1]
                        : null,
                    pathToTargetPosition: candidate.path,
                    targetEnemy: candidate.enemyUnit,
                };
            }
            return null;
        },
    };
};
export default moveTowardsEnemyStrategyFactory;
